"use client";

import { Icon } from "@/components/Icons";
import { Modal } from "@arco-design/web-react";
import React, { useContext, useEffect, useState } from "react";
import "./index.scss";
import Image from "next/image";
import { MODAL_BG } from "@/cdn-resources";
import { IconExclamationCircle } from "@arco-design/web-react/icon";
import { usePathname } from "next/navigation";
import { DeviceContext } from "@/app/DeviceProvider";

const MobileTipModal = () => {
  const [visible, $visible] = useState(false);
  const path = usePathname();
  const deviceCtx = useContext(DeviceContext);

  useEffect(() => {
    if (path && deviceCtx?.isMobile) $visible(deviceCtx?.isMobile);
  }, [path, deviceCtx?.isMobile]);

  return (
    <Modal
      visible={visible}
      onCancel={() => $visible(false)}
      autoFocus={false}
      focusLock={true}
      className="yf-tip-mobile-modal"
      footer={null}
      closeIcon={
        <Icon.Close width={30} height={30} className="relative z-20" />
      }
    >
      <Image
        src={MODAL_BG}
        width={340}
        height={174}
        alt="tipModal"
        className="absolute top-0 left-0 w-full z-0"
      />
      <div className="w-full text-[#17215C] z-10 relative text-center">
        <IconExclamationCircle />
        <h2 className="text-lg font-semibold mt-3 mb-3">
          Full Experience on Computer
        </h2>
        <p className="text-sm font-light">
          Current features are limited. Please use a computer for the full
          experience.
        </p>
      </div>
    </Modal>
  );
};

export default MobileTipModal;
